<div class="modal-header">
  <h5 class="modal-title">Camera Info</h5>
  <button class="close-button" (click)="activeModal.dismiss()">×</button>
</div>
<div class="modal-body">
  <div style="font-weight: bold; text-align: center" class="fs-6">
    Camera Name: {{camera?.label}} &bull; Sensor ID: {{camera?.id}} &bull; Camera ID: {{camera?.camera?.[0]?.id}}
  </div>
  <table style="background-color: #5d99fb;" class="table custom-table">
    <tr>
      <td style="width: 120px; text-align: right">Camera Location</td>
      <td></td>
    </tr>
    <tr>
      <td style="width: 120px; text-align: right">Building:</td>
      <td style="padding-left: 15px"> {{camera?.building?.label}}</td>
    </tr>
    <tr>
      <td style="width: 120px; text-align: right">Floor:</td>
      <td style="padding-left: 15px"> {{camera?.floor?.label}}</td>
    </tr>
    <tr>
      <td style="width: 120px; text-align: right">Room:</td>
      <td style="padding-left: 15px"> {{camera?.room?.label}}</td>
    </tr>
  </table>

  <div style="height: 210px;" class="custom-scroll">
    <div style="margin-top: 0px" class="fs-6">
      Current Camera Sessions [{{cameraSessions.length}}]:
    </div>
    <div>
      <table style="background-color: #5d99fb;" class="table custom-table">
        <tr style="border-bottom: solid 1px #666">
          <td>Session ID</td>
          <td>User ID</td>
          <td>Start Time (UTC)</td>
          <td>Mode</td>
          <td>Being Viewed</td>
        </tr>
        @for (session of cameraSessions; track session) {
          <tr>
            <td>{{session.id}}</td>
            <td>{{session.userId}}</td>
            <td>{{session.startTime?.slice(0,19)?.replace('T', ' ')}}</td>
            <td>{{session.mode}}</td>
            <td>
              {{session.beingViewed}}
              @if (session.beingViewed === 'No') {
                <i class="fa fa-trash bg-transparent text-white"
                style="cursor: pointer;" title="stop session" (click)="stopCameraSession(session)"></i>
              }
            </td>
          </tr>
        }
      </table>
    </div>

    <div style="margin-top: 15px" class="fs-6">
      Past Camera Sessions (last 7 days) [{{cameraSessionHistory.length}}]:
    </div>
    <div>
      <table style="background-color: #5d99fb;" class="table custom-table">
        <tr style="border-bottom: solid 1px #666">
          <td>Session ID</td>
          <td>User ID</td>
          <td>Start Time (UTC)</td>
          <td>End Time (UTC)</td>
        </tr>
        @for (session of cameraSessionHistory; track session) {
          <tr>
            <td>{{session.cameraSessionId}}</td>
            <td>{{session.userId}}</td>
            <td>{{session.startTime?.slice(0,19)?.replace('T', ' ')}}</td>
            <td>{{session.endTime?.slice(0,19)?.replace('T', ' ')}}</td>
          </tr>
        }
      </table>
    </div>
  </div>
</div>